import type { Extension, HealthcareService } from "fhir/r3"
export const CANCELLATION_QUESTIONNAIRE_IDENTIFIER = "CancellationRequestQuestionnaire"
export const RESCHEDULE_QUESTIONNAIRE_IDENTIFIER = "ReschedulingRequestQuestionnaire"

export function getProviderName(healthcareService: HealthcareService): string {
  return healthcareService.providedBy?.display ?? ""
}
export function getPortalName(healthcareService: HealthcareService): string {
  const tags = healthcareService.meta?.tag ?? []

  return tags[0]?.display ?? "Wayfinder Services"
}

export function getRescheduleInstructions(healthcareService: HealthcareService): string[] {
  const extensions = getExtensions(healthcareService, "ReschedulingInstructions")
  const instructions = extensions.map((instruction) => instruction.valueString ?? "").filter((it) => it.length > 0)

  if (instructions.length === 0) {
    const contactName = healthcareService.name ?? "booking team"
    return [`Contact the ${contactName} if you need further assistance with your appointment`]
  }
  return instructions
}
export function getRescheduleQuestionnaireReference(healthcareService: HealthcareService) {
  const questionnaireExtension = getExtensions(healthcareService, RESCHEDULE_QUESTIONNAIRE_IDENTIFIER)[0]

  return questionnaireExtension?.valueReference?.reference ?? ""
}
export function getCancellationQuestionnaireReference(healthcareService: HealthcareService) {
  const questionnaireExtension = getExtensions(healthcareService, CANCELLATION_QUESTIONNAIRE_IDENTIFIER)[0]

  return questionnaireExtension?.valueReference?.reference ?? ""
}
export function getQuestionnaireId(healthcareService: HealthcareService, questionnaireIdentifier: string): string {
  const questionnaireExtension = getExtensions(healthcareService, questionnaireIdentifier)[0]

  return (questionnaireExtension?.valueReference?.reference ?? "").split("/").slice(-1)[0]
}
export function getExtensions(healthcareService: HealthcareService, extensionIdentifier: string): Extension[] {
  return (healthcareService.extension ?? []).filter((extension) => extension.url.includes(extensionIdentifier))
}
